//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { connect } from 'react-redux';

//firebase
import { db } from 'assets/firebase';

//algolia full text search
import { algolia } from 'assets/algolia';

// @material-ui/style
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

//materialKit components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";

//spiffy
import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog.jsx";
import ProductEditor from "components/ProductEditor/ProductEditor.jsx";

//icons
import Visibility from "@material-ui/icons/Visibility";


const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};


function compareName(a,b) {

  var x = a.ProductName.toLowerCase();
  var y = b.ProductName.toLowerCase();
  
  if (x < y)
      return -1;
  if (x > y)
      return 1;
  return 0;
}

function compareSKU(a,b) {

  var x = Number(a.sku);
  var y = Number(b.sku);
  
  if (x < y)
      return -1;
  if (x > y)
      return 1;
  return 0;
}

function compareCost(a,b) {

  var x = Number(a.Price);
  var y = Number(b.Price);
  
  if (x < y)
      return -1;
  if (x > y)
      return 1;
  return 0;
}

function compareListPrice(a,b) {

  var x = Number(a.ListPrice);
  var y = Number(b.ListPrice);
  
  if (x < y)
      return -1;
  if (x > y)
      return 1;
  return 0;
}

function compareVisibility(a,b) {

  var x = a.IsVisible;
  var y = b.IsVisible;
  
  if (x < y)
      return -1;
  if (x > y)
      return 1;
  return 0;
}

class ProductList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      currentSort: 'name'
    }
    
    this.productUpdated = this.productUpdated.bind(this);
  }

  componentDidMount() {
    this.refreshProducts();
  }

  productUpdated() { //todo, just update the product instead of refreshing from db?
    this.refreshProducts();
  }

  deleteProduct(product) {
    
    db.deleteProduct(product.id).then(() => {
      algolia.deleteProduct(product);

      var products = this.state.products;
      for(var i = 0; i < products.length; i++) {
        if(products[i].id === product.id) {
          products.splice(i,1);
          break;
        }
      }
      this.setState({products:products});
    });
  }

  refreshProducts() {
    
    this.setState({products: []}, function() {
        
      db.getProducts().then(products => {
            
        for(var i = 0; i < products.length; i++) {
          
          if(!products[i].Photos)
          products[i].Photos = [];

          try {
            products[i].Price = Number(products[i].Cost).toFixed(2);
            products[i].ListPrice = Number(products[i].ListPrice).toFixed(2);
          }
          catch(exception) {

          }
        };

        this.setState({products: products, currentSort:'name'});   
      });
    });
  }

  visibleText(isVisible) {
    if(isVisible)
      return "Yes";
    else
      return "No";
  }

  iconColor(value) {
    if(value)
      return "#3fa31b";
    else
      return "silver";
  }

  adminOnly() {
    if(this.props.user.userType === 'admin') 
      return "block";
    else
      return "none";
  }

  trim(value, maxLength) {
    if(value.length > maxLength)
        return value.substring(0,maxLength) + "...";
    else
        return value;
  }

  sortBy(property) {

    var products = this.state.products;

    if(this.state.currentSort === property) { //reverse array

      var reversed = [];
      for(var i = products.length -1; i > -1; i--) 
        reversed.push(products[i]);

      products = reversed;

    } else {

      if(property === 'name')
        products.sort(compareName);
      else if(property === 'sku')
        products.sort(compareSKU);
      else if(property === 'cost')
        products.sort(compareCost);
      else if(property === 'list')
        products.sort(compareListPrice);
      else if(property === 'visible')
        products.sort(compareVisibility);
    }

    this.setState({products: products, currentSort: property});
  }

  formattedCurrency(value) {
    if(!value)
      return "";
    else {
      return "$" + Number(value).toFixed(2);
    }
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <GridContainer>
                <GridItem xs={12} sm={11} >
                  <h4 className={classes.cardTitleWhite}>Products</h4>
                  <p className={classes.cardCategoryWhite}>
                    
                  </p>
                </GridItem> 
                
                <GridItem xs={12} sm={12} md={1} style={{textAlign:"right"}}>
                  <Tooltip id="tooltip-top-start" title="Add Product" placement="top" classes={{ tooltip: classes.tooltip }} >
                      <ProductEditor onChange={this.productUpdated}
                        product={{
                          ProductName: "", 
                          BriefDescription: "", 
                          CategoryID:"",
                          Price: 0,
                          ListPrice: 0,
                          sku: "",
                          Photos: [],
                          IsVisible: false
                        }} />
                  </Tooltip>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
             
              <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                      <TableCell style={{padding:"3px"}}>

                      </TableCell>
                      <TableCell style={{padding:"3px", color:"green", cursor:"pointer"}} onClick={() => this.sortBy("name")}>
                          Name
                      </TableCell>
                      <TableCell style={{padding:"3px", color:"green", cursor:"pointer"}} onClick={() => this.sortBy("sku")}>
                          SKU
                      </TableCell>
                      <TableCell style={{padding:"3px", color:"green", cursor:"pointer", textAlign:"right"}} onClick={() => this.sortBy("cost")}>
                          Cost
                      </TableCell>
                      <TableCell style={{padding:"3px", color:"green", cursor:"pointer", textAlign:"right"}} onClick={() => this.sortBy("list")}>
                          List
                      </TableCell>
                      <TableCell style={{padding:"3px", color:"green", cursor:"pointer", textAlign:"right"}} onClick={() => this.sortBy("visible")}>
                          Status
                      </TableCell>
                      <TableCell style={{padding:"3px"}}>
                      </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.products.map(value => (
                    <TableRow key={value.id} className={classes.tableRow}>
                      <TableCell className={classes.tableActions} style={{padding:"3px"}}>
                        <Tooltip
                          id="tooltip-top"
                          title="Edit Product"
                          placement="top"
                          classes={{ tooltip: classes.tooltip }}
                        >
                          <ProductEditor product={value} onChange={this.productUpdated} />
                        </Tooltip>
                      </TableCell>
                      <TableCell className={classes.tableCell} style={{padding:"3px"}} title={value.ProductName}>
                        {this.trim(value.ProductName,50)}
                      </TableCell>
                      <TableCell className={classes.tableCell} style={{padding:"3px"}}>
                        {value.sku}
                      </TableCell>
                      <TableCell className={classes.tableCell} style={{padding:"3px", textAlign:"right"}}>
                        {this.formattedCurrency(value.Price)}
                      </TableCell>
                      <TableCell className={classes.tableCell} style={{padding:"3px", textAlign:"right"}}>
                        {this.formattedCurrency(value.ListPrice)}
                      </TableCell>
                      <TableCell style={{padding:"3px", textAlign:"right"}}>
                        <Visibility style={{color:this.iconColor(value.IsVisible)}} />
                      </TableCell>
                      <TableCell className={classes.tableActions} style={{padding:"6px", width:"23px"}}> 
                        <Tooltip id="tooltip-top-start" title="Delete Product" placement="top" classes={{ tooltip: classes.tooltip }} >
                          <ConfirmDialog header="Confirm Delete" description="Are you sure you want to delete this product? This action cannot be undone." confirmed={() => this.deleteProduct(value)} />
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

ProductList = connect(mapStateToProps)(ProductList);
export default withStyles(styles)(ProductList);



// WEBPACK FOOTER //
// ./src/views/ProductsList/ProductsList.jsx